import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-45810898"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "fapiaoList__content" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  key: 0,
  class: "separator"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = {
  key: 2,
  class: "separator"
}
const _hoisted_7 = ["download", "href"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "separator" }, null, -1))
const _hoisted_9 = ["onClick"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "separator" }, null, -1))
const _hoisted_11 = ["onClick"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "separator" }, null, -1))
const _hoisted_13 = ["onClick"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "separator" }, null, -1))
const _hoisted_15 = ["onClick"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "separator" }, null, -1))
const _hoisted_17 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_routeTab = _resolveComponent("routeTab")!
  const _component_a_range_picker = _resolveComponent("a-range-picker")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_app_enterprise_input = _resolveComponent("app-enterprise-input")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_app_table = _resolveComponent("app-table")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_detail_drawer = _resolveComponent("detail-drawer")!
  const _component_rel_order_model = _resolveComponent("rel-order-model")!
  const _component_red_flush_apply_modal = _resolveComponent("red-flush-apply-modal")!
  const _component_red_flush_detail_modal = _resolveComponent("red-flush-detail-modal")!
  const _component_charge_list = _resolveComponent("charge-list")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createBlock(_component_a_card, { class: "utils__pageContainer fapiaoList" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_routeTab),
        _createVNode(_component_a_form, {
          class: "fl-clean filterForm fapiaoList__filterForm",
          model: _ctx.filterParams,
          layout: 'inline'
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, { label: "申请日期" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_range_picker, {
                  value: _ctx.filterParams.timeRange,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filterParams.timeRange) = $event)),
                  format: "YYYY-MM-DD",
                  placeholder: ['起始时间', '结束时间']
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "发票类型" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  value: _ctx.filterParams.invoiceType,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filterParams.invoiceType) = $event)),
                  style: {"width":"180px"},
                  placeholder: "发票类型"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.typeList, (item) => {
                      return (_openBlock(), _createBlock(_component_a_select_option, {
                        key: item.value,
                        value: item.value
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.label), 1)
                        ]),
                        _: 2
                      }, 1032, ["value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "发票状态" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  value: _ctx.filterParams.invoiceStatus,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filterParams.invoiceStatus) = $event)),
                  style: {"width":"180px"},
                  placeholder: "发票状态"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statusList, (item) => {
                      return (_openBlock(), _createBlock(_component_a_select_option, {
                        key: item.value,
                        value: item.value
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.label), 1)
                        ]),
                        _: 2
                      }, 1032, ["value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "发票抬头" }, {
              default: _withCtx(() => [
                _createVNode(_component_app_enterprise_input, {
                  value: _ctx.filterParams.enterpriseId,
                  "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filterParams.enterpriseId) = $event)),
                  style: {"width":"180px"},
                  "with-default-all": ""
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "发票来源" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  value: _ctx.filterParams.invoiceApplyType,
                  "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.filterParams.invoiceApplyType) = $event)),
                  style: {"width":"180px"},
                  placeholder: "发票来源"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sourceList, (item) => {
                      return (_openBlock(), _createBlock(_component_a_select_option, {
                        key: item.code,
                        value: item.code
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.value), 1)
                        ]),
                        _: 2
                      }, 1032, ["value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_button, {
                  type: "primary",
                  ghost: "",
                  onClick: _ctx.onRefreshTable
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("查询")
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_a_button, {
                  type: "primary",
                  style: {"margin-left":"10px"},
                  onClick: _ctx.onExport
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("导出")
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"]),
        _createVNode(_component_app_table, {
          ref: "tableRef",
          size: "default",
          "row-key": "id",
          "show-pagination": true,
          columns: _ctx.tableColumns,
          data: _ctx.loadTableData,
          scroll: { x: true }
        }, {
          "view-order": _withCtx(({ record }) => [
            _createElementVNode("a", {
              href: "#",
              onClick: ($event: any) => (_ctx.onViewRelOrder(record))
            }, "查看", 8, _hoisted_2)
          ]),
          action: _withCtx(({ record }) => [
            _createElementVNode("a", {
              href: "#",
              onClick: _withModifiers(($event: any) => (_ctx.viewDetail(record.invoiceRecordId)), ["prevent"])
            }, "详情", 8, _hoisted_3),
            (record.invoiceStatus === 1)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (record.invoiceUrl)
                    ? (_openBlock(), _createElementBlock("i", _hoisted_4))
                    : _createCommentVNode("", true),
                  (record.invoiceUrl)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 1,
                        href: "#",
                        onClick: ($event: any) => (_ctx.$vp(record.invoiceUrl))
                      }, "查看发票", 8, _hoisted_5))
                    : _createCommentVNode("", true),
                  (record.invoicePdfUrl)
                    ? (_openBlock(), _createElementBlock("i", _hoisted_6))
                    : _createCommentVNode("", true),
                  (record.invoicePdfUrl)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 3,
                        download: `Fapiao-${record.id}.pdf`,
                        href: record.invoicePdfUrl
                      }, "导出PDF", 8, _hoisted_7))
                    : _createCommentVNode("", true),
                  (_ctx.canApplyRedFlush(record))
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                        _hoisted_8,
                        _createElementVNode("a", {
                          href: "#",
                          onClick: _withModifiers(($event: any) => (_ctx.onApplyRedFlush(record)), ["prevent"])
                        }, "申请红冲", 8, _hoisted_9)
                      ], 64))
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true),
            (record.invoiceStatus === 2)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _hoisted_10,
                  _createElementVNode("a", {
                    href: "#",
                    onClick: _withModifiers(($event: any) => (_ctx.showError(record.errorMsg)), ["prevent"])
                  }, "失败原因", 8, _hoisted_11)
                ], 64))
              : _createCommentVNode("", true),
            (record.invoiceStatus === 3 || record.invoiceStatus === 4)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  _hoisted_12,
                  _createElementVNode("a", {
                    href: "#",
                    onClick: _withModifiers(($event: any) => (_ctx.onViewRedFlushDetail(record)), ["prevent"])
                  }, "红冲详情", 8, _hoisted_13)
                ], 64))
              : _createCommentVNode("", true),
            (record.invoiceStatus === 5)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                  _hoisted_14,
                  _createElementVNode("a", {
                    href: "#",
                    onClick: _withModifiers(($event: any) => (_ctx.onViewRedFlushDetail(record)), ["prevent"])
                  }, "红冲详情", 8, _hoisted_15),
                  (_ctx.canApplyRedFlush(record))
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _hoisted_16,
                        _createElementVNode("a", {
                          href: "#",
                          onClick: _withModifiers(($event: any) => (_ctx.onApplyRedFlush(record)), ["prevent"])
                        }, "重新申请", 8, _hoisted_17)
                      ], 64))
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["columns", "data"])
      ]),
      _createVNode(_component_a_modal, {
        visible: _ctx.errorModalVisible,
        "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.errorModalVisible) = $event)),
        title: "失败原因",
        footer: null
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.currentErrorMsg), 1)
        ]),
        _: 1
      }, 8, ["visible"]),
      _createVNode(_component_detail_drawer, { ref: "detailDrawerRef" }, null, 512),
      _createVNode(_component_rel_order_model, { ref: "relOrderModelRef" }, null, 512),
      _createVNode(_component_red_flush_apply_modal, {
        ref: "redFlushApplyRef",
        onComplete: _ctx.onRefreshTable
      }, null, 8, ["onComplete"]),
      _createVNode(_component_red_flush_detail_modal, { ref: "redFlushDetailRef" }, null, 512),
      _createVNode(_component_a_modal, {
        visible: _ctx.confirmVisible,
        "onUpdate:visible": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.confirmVisible) = $event)),
        title: "导出发票记录",
        "confirm-loading": _ctx.exporting,
        "ok-text": "导出",
        onOk: _ctx.onConfirmExport
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_form, {
            model: _ctx.exportParams,
            "label-col": { span: 5 }
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_form_item, { label: "申请时间" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_range_picker, {
                    value: _ctx.exportParams.timeRange,
                    "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.exportParams.timeRange) = $event)),
                    format: "YYYY-MM-DD",
                    placeholder: ['起始时间', '结束时间'],
                    style: {"width":"250px"},
                    "disabled-date": _ctx.isDateDisable,
                    onCalendarChange: _ctx.onCalendarChange,
                    onOpenChange: _ctx.onOpenChange
                  }, null, 8, ["value", "disabled-date", "onCalendarChange", "onOpenChange"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"])
        ]),
        _: 1
      }, 8, ["visible", "confirm-loading", "onOk"]),
      _createVNode(_component_charge_list, {
        ref: "chargeOrderRef",
        type: 1
      }, null, 512)
    ]),
    _: 1
  }))
}